<template>
  <div class="transaction-store-filter">
    <b-row class="mb-5">
      <b-col md="2">
        <b-form>
          <Autosuggest
            :model="searchStore"
            :suggestions="filteredStores"
            @select="onSelected"
            :limit="10"
            @change="onInputChangeStore"
            :placeholder="'cửa hàng'"
            suggestionName="name"
          >
            <template #custom="{ suggestion }">
              <div style="display: flex; align-items: center">
                {{ suggestion.item.name }}
              </div>
            </template>
          </Autosuggest>
        </b-form>
      </b-col>
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Từ"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="filterData.fromDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-input-group>
          <date-picker
            placeholder="Đến"
            class="form-control form-control-sm"
            :config="dpConfigs.date"
            v-model="filterData.toDate"
          ></date-picker>
        </b-input-group>
      </b-col>
      <b-col md="1">
        <b-button
          style="font-weight: 600; width: 70px"
          variant="primary"
          size="sm"
          @click="onFilter"
        >Lọc
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';

export default {
  name: 'TransactionStoreFilter',
  components: {
    datePicker,
    Autosuggest,
  },
  props: {
    initialFilter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filterData: {
        page: 1,
        pageSize: 10,
        storeId: '',
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY'),
      },
      searchStore: '',
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      filteredStores: [],
      storesList: [],
    };
  },
  created() {
    // Initialize filter with any provided initial values
    this.filterData = { ...this.filterData, ...this.initialFilter };
    if (this.initialFilter.storeId) {
      this.searchStore = this.initialFilter.storeText || '';
    }
  },
  methods: {
    /**
     * Emit filter event with current filter data
     */
    onFilter() {
      const formattedFilter = this.formatFilterData();
      this.$emit('filter', formattedFilter);
    },

    /**
     * Format filter data for API request
     */
    formatFilterData() {
      return {
        ...this.filterData,
        storeId:
          this.filterData.storeId === '' ? null : this.filterData.storeId,
      };
    },

    /**
     * Set stores data and initialize filtered stores
     */
    setStores(stores) {
      this.storesList = [
        {
          id: '',
          name: 'Tất cả cửa hàng',
          shortName: 'Tat ca cua hang',
        },
        ...stores,
      ];

      this.filteredStores = this.storesList;
    },

    /**
     * Set single store when user has access to only one store
     */
    setSingleStore(store) {
      this.searchStore = store.name;
      this.filterData.storeId = store.id;
    },

    /**
     * Chọn cửa hàng (vd: cửa hiện tại theo API get-by-user khi user có nhiều cửa)
     */
    setSelectedStore(store) {
      if (!store) {
        return;
      }
      this.searchStore = store.name;
      this.filterData.storeId = store.id;
    },

    /**
     * Handle store selection
     */
    onSelected(option) {
      if (option) {
        this.searchStore = option.item.name;
        this.filterData.storeId = option.item.id;
      }
    },

    /**
     * Handle store input change
     */
    onInputChangeStore(text) {
      if (!text) {
        text = '';
      }

      this.filteredStores = this.storesList
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            (item.shortName &&
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1)
          );
        })
        .slice(0, 10);
    },

    /**
     * Reset filter to default values
     */
    resetFilter() {
      this.filterData = {
        page: 1,
        pageSize: 10,
        storeId: '',
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY'),
      };
      this.searchStore = 'Tất cả cửa hàng';
    },
  },
};
</script>

<style lang="scss">
</style>
